import React from 'react'
import dayjs from 'dayjs'
import styled from 'styled-components'
import { getPriorityLabel } from './PatternTab'

const StyledTooltip = styled.div`
    height: fit-content;
    width: 150px;
    padding: 7px;
    border-radius: 5px;
    background: #ffffff;
    opacity: 0.8;
`

interface TooltipProps {
  active?: boolean;
  payload?: Array<{
    name: string;
    value: number | string;
    payload: {
      pattern: string;
    };
  }>;
  label?: string;
}

interface LabelData {
  label: string;
  value: string | number;
}

const CustomTooltip: React.FC<TooltipProps> = ({ active, payload }) => {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const labels: LabelData[] = payload.map(({ name, value }) => {
    switch (name) {
      case 'priority':
        return { label: 'Priority', value: getPriorityLabel(value as number) };
      case 'time':
        return { label: 'Time', value: dayjs(value).format('D MMM YYYY, dddd HH:mm') };
      case 'rank':
        return { label: 'Rank', value };
      default:
        return { label: 'Error', value: 'Unknown' };
    }
  });

  const timeString = labels.find(item => item.label === 'Time')?.value as string;

  labels.push({
    label: 'Pattern',
    value: payload[0].payload.pattern.split('').join(' '),
  });

  return (
    <StyledTooltip>
      {labels.map(({ label, value }) => (
        label !== 'Time' && (
          <p key={label}>
            {label}: <strong>{value}</strong>
          </p>
        )
      ))}
      <p key='Time'>
        <strong>{timeString}</strong>
      </p>
    </StyledTooltip>
  );
};

export default CustomTooltip;